// queryParam.js
import CryptoJS from "crypto-js";

const SECRET_KEY = process.env.REACT_APP_CRYPTING_KEY;

export const decryptSearchParams = (encryptedParams) => {
  try {
    if (!encryptedParams) {
      console.warn("No encrypted parameters provided for decryption");
      return null;
    }
    const decodedParams = decodeURIComponent(encryptedParams); // Decode URL-safe string
    const bytes = CryptoJS.AES.decrypt(decodedParams, SECRET_KEY);
    const decrypted = bytes.toString(CryptoJS.enc.Utf8);
    if (!decrypted) {
      console.warn("Decrypted data is empty");
      return null;
    }
    return JSON.parse(decrypted); // Parse back into an object
  } catch (error) {
    console.error("Decryption failed:", error.message);
    return null;
  }
};